<template id="drilldown-b1">
    <section>
    <div class ="row ml-3">
        <iframe src="https://forewarn.compegence.com:3000/#!/l1/Territory%20Salesman/district"  height="600" width="100%" frameBorder="0"></iframe>
    </div>
    </section>
</template>
<script>
    export default {
        name: "drilldown-b1"
    }
</script>
<style>

</style>